'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');
const BREAKPOINTS = {
    sm: 441,
    md: 1024,
    lg: 1440
}

function isPageDesignerEditMode() {
    return window.location.pathname.includes('__SYSTEM__Page-Show');
}

var clearSelection = function (element) {
    $(element).closest('.dropdown').children('.dropdown-menu').children('.top-category')
        .detach();
    $(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show').children('.dropdown-menu').attr('aria-hidden', 'true');
    $(element).closest('.dropdown.show').removeClass('show');
    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
    $(element).closest('li').detach();
};

$(document).ready(function () {
    let navToggleButton = $('.nav-link.dropdown-toggle');
    navToggleButton.unbind('mouseenter');
    navToggleButton.on('click', function (e) {
        e.preventDefault();
        $('.nav-link.dropdown-toggle').not($(this)).siblings('.honda-nav-menu').removeClass("show");
        $('.nav-link.dropdown-toggle').not($(this)).removeClass("red-font-underline");
        $(this).siblings('.honda-nav-menu').toggleClass("show");
        $(this).toggleClass("red-font-underline");
        if ($(this).attr('id') === 'cars') {
            var isShown = $(this).siblings('.honda-nav-menu').hasClass('show');
            if (isShown) {
                if (window.location.hash !== '#!/cars') {
                    window.location.hash = '#!/cars';
                }
            } else {
                if (window.location.hash === '#!/cars') {
                    history.replaceState("", document.title, window.location.pathname + window.location.search);
                }
            }
        }
    });
    if (window.location.hash === '#!/cars') {
        var carsToggle = $('#cars');
        carsToggle.addClass('red-font-underline');
        carsToggle.siblings('.honda-nav-menu').addClass('show');
    }
});

$('.mobile-nav-menu-close-button').on('click', function (e) {
    e.preventDefault();
    $('.menu-toggleable-left').removeClass('in');
    $('.modal-background').hide();
    $('.navbar-toggler').focus();
    $('.main-menu').attr('aria-hidden', 'true');
    $('.main-menu').siblings().attr('aria-hidden', 'false');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.mobile-navbar-toggler').removeClass('d-none');
    $(this).addClass('d-none');
    $('body').css('overflow', ''); // Enable scroll
    window.location.hash = '#!';
});

$('.mobile-navbar-toggler').on('click', function (e) {
    e.preventDefault();
    $(this).addClass('d-none');
    $('.mobile-nav-menu-close-button').removeClass('d-none');
    $('body').css('overflow', 'hidden'); // Disable scroll
});

$(".honda-nav-menu #buildandprice").attr('data-toggle', 'modal').attr('data-target', '#selectCarModal');
$(".honda-nav-menu #loadabuild").attr('data-toggle', 'modal').attr('data-target', '#configurator-load-a-build-modal');

$('#buildandprice').on('click', function (e) {
    e.preventDefault();
});

$(function() {
    var offerpageCheck = $('#maincontent').find('#offers.storepage');
    if(offerpageCheck.length && !isPageDesignerEditMode()) {
        $('#offer-page-start-your-build-cta').on('click', () => {
            $('#offer-page-modal').modal('hide');
            $('#selectCarModal').modal('show');
        });
    }
});

$('#offer-page-modal').on('hidden.bs.modal', function () {
    $('body').addClass('modal-open');
    if ($('.modal.show').length == 0) {
        $('body').removeClass('modal-open');
    }
});

module.exports = function () {
    var isDesktop = function (element) {
        return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };

    // TODO: Temporary disable header banner as this component won't work with current design
    // var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    // $('.header-banner .close').on('click', function () {
    //     $('.header-banner').addClass('d-none');
    //     window.sessionStorage.setItem('hide_header_banner', '1');
    // });

    // if (!headerBannerStatus || headerBannerStatus < 0) {
    //     $('.header-banner').removeClass('d-none');
    // }

    keyboardAccessibility(
        '.main-menu .nav-link, .main-menu .dropdown-link', {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    if (!(menuItem.next().length > 0)) { // if this is the last menuItem
                        menuItem.parent().parent().find('li > a') // set focus to the first menuitem
                            .first()
                            .focus();
                    } else {
                        menuItem.next().children().first().focus();
                    }
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                } else if (menuItem.prev().length === 0) { // first menuItem
                    menuItem.parent().parent().removeClass('show')
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                    menuItem.parent().children().last().children() // set the focus to the last menuItem
                        .first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first()
                        .focus()
                        .attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show') ?
                    menuItem :
                    menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link')
                    .attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            }
        },
        function () {
            return $(this).parent();
        }
    );

    $('.dropdown:not(.disabled) [data-toggle="dropdown"]')
        .on('click', function (e) {
            if (!isDesktop(this)) {
                $('.modal-background').show();
                // copy parent element into current UL
                var li = $('<li class="dropdown-item top-category" role="button"></li>');
                var link = $(this).clone().removeClass('dropdown-toggle')
                    .removeAttr('data-toggle')
                    .removeAttr('aria-expanded')
                    .attr('aria-haspopup', 'false');
                li.append(link);
                var closeMenu = $('<li class="nav-menu"></li>');
                closeMenu.append($('.close-menu').first().clone());
                $(this).parent().children('.dropdown-menu')
                    .prepend(li)
                    .prepend(closeMenu)
                    .attr('aria-hidden', 'false');
                // copy navigation menu into view
                $(this).parent().addClass('show');
                $(this).attr('aria-expanded', 'true');
                $(link).focus();
                $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
                e.preventDefault();
            }
        })
        .on('mouseenter', function () {
            if (isDesktop(this)) {
                var eventElement = this;
                $('.navbar-nav > li').each(function () {
                    if (!$.contains(this, eventElement)) {
                        $(this).find('.show').each(function () {
                            clearSelection(this);
                        });
                        if ($(this).hasClass('show')) {
                            $(this).removeClass('show');
                            $(this).children('ul.dropdown-menu').removeClass('show');
                            $(this).children('.nav-link').attr('aria-expanded', 'false');
                        }
                    }
                });
                // need to close all the dropdowns that are not direct parent of current dropdown
                $(this).parent().addClass('show');
                $(this).siblings('.dropdown-menu').addClass('show');
                $(this).attr('aria-expanded', 'true');
            }
        });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        $('.menu-toggleable-left').removeClass('in');
        $('.modal-background').hide();

        $('.navbar-toggler').focus();

        $('.main-menu').attr('aria-hidden', 'true');
        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        $('.navbar-nav').find('.top-category').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.navbar-nav').find('.show').removeClass('show');
        $('.menu-toggleable-left').removeClass('in');

        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');

        $('.modal-background').hide();
    });

    $('.header .navbar-toggler').click(function (e) {
        e.preventDefault();
        $('.main-menu').toggleClass('in');
        $('.modal-background').show();

        $('.main-menu').removeClass('d-none');
        $('.main-menu').attr('aria-hidden', 'false');
        $('.main-menu').siblings().attr('aria-hidden', 'true');
        $('header').siblings().attr('aria-hidden', 'true');

        $('.main-menu .nav.navbar-nav .nav-link').first().focus();
    });

    keyboardAccessibility(
        '.navbar-header .user', {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.next().children().first().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function () { // escape
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            },
            9: function () { // tab
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            }
        },
        function () {
            var $popover = $('.user .popover li.nav-item');
            return $popover;
        }
    );

    $('.navbar-header .user').on('mouseenter focusin', function () {
        if ($('.navbar-header .user .popover').length > 0) {
            $('.navbar-header .user .popover').addClass('show');
            $('.user').attr('aria-expanded', 'true');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        $('.navbar-header .user .popover').removeClass('show');
        $('.user').attr('aria-expanded', 'false');
    });
    $('body').on('click', '#myaccount', function (event) {
        event.preventDefault();
    });

    $('body').on('click', '.build-and-buy-modal', function (event) {
        $('#selectCarModal').modal();
    });


    if (window.innerWidth < BREAKPOINTS.sm) {
        $("#header-search-lg").appendTo($(".mobile-navbar-container").find("#mobile-search-sm"));
    }
    $('.search-btn').on('click', function () {
        var serachInput = $('.searchSite-js');
        if (window.innerWidth < BREAKPOINTS.sm) {
            serachInput = $("#mobile-search-sm > #header-search-lg");
        }
        if (serachInput.hasClass('d-none')) {
            serachInput.removeClass('d-none');
        } else {
            serachInput.addClass('d-none');
        }
    });

    $('body').on('keydown', '.search-field', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    });
};
